export const PREFERENCE_SCOPES = {
  UNSCOPED: 'unscoped',
  SCOPED: 'scoped',
}
